import CryptoJS from "crypto-js";
import { lcGet, ssGet } from "./utils";

let decodeStr = '8s9D7k8P2m7Q9z4X'//getDecode();

// let withSign = false; "GPnr8*QSD^hmHRKK",
// var ciphertext = CryptoJS.AES.encrypt(
//   "a6LOGML8p4&lxhxm",
//   'JsSign-decode-passw0rd-123#'
// ).toString();

// console.log("ciphertext", ciphertext);

function paramsDecode (params) {
  let withSign = true;
  params.nonce_str = randomString(6);
  params.token = lcGet("token");
  let user = ssGet('user');
  if (user) {
    user = JSON.parse(user);
    params.user_name = user.user_name;
  }
  return formatParams(params, { withSign: withSign });
}

function randomString (length) {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function formatParams (params, options = {}) {
  let result = "";
  for (let prop in params) {
    let val = "";
    if (params[prop] === 0 || params[prop]) {
      val = params[prop];
      if (result.length > 0) {
        result += `&${prop}=${val}`;
      } else {
        result += `${prop}=${val}`;
      }
    }
  }
  if (options.withSign) {
    let resultMD5 = CryptoJS.MD5(`${result}&key=${decodeStr}`);
    result += `&sign=${resultMD5}`;
  }
  return "?" + result;
}

function getDecode () {
  let encodeStr =
    "U2FsdGVkX18OJWsbsXyX1iSaVlt4WwdqCpuN13jB9dlUSRb/Lw2jzcbTk7UK6QsO";

  let bytes = CryptoJS.AES.decrypt(encodeStr, "JsSign-decode-passw0rd-123#");

  return bytes.toString(CryptoJS.enc.Utf8);
}

// function getWithSign () {
//   let withSign = localStorage.getItem("withSign");
//   if (withSign) {
//     return withSign === "2";
//   } else {
//     return false;
//   }
// }

// 加密函数
function encryptAES (data, key) {
  const iv = CryptoJS.lib.WordArray.random(16); // 生成随机的初始化向量
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(data),
    CryptoJS.enc.Utf8.parse(key),
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  return {
    iv: iv.toString(CryptoJS.enc.Base64),
    encryptedData: encrypted.toString(),
  };
}

// 解密函数
function decryptAES (iv, encryptedData, key) {
  const decrypted = CryptoJS.AES.decrypt(
    encryptedData,
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Base64.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}

const key = "BHSl8GwHqkPhWK4J"; //
export { paramsDecode, encryptAES, decryptAES, key };
